import React from 'react';
import './Header.css';
import { formatAddress, formatNumber } from '../utils/formatters';



const Header = ({ account, usdtBalance, onDisconnect, onShowTelegram }) => {
  return (
    <header className="header">
      <div className="header-content">
        <div className="header-brand">
          <img src="/logo.png" alt="Time to Time" className="header-logo" />
          <span className="header-title">TIME TO TIME</span>
        </div>

        <div className="header-actions">
          <button className="header-btn telegram-btn" onClick={onShowTelegram} title="Telegram">
            <img src="/assets/gifs/t2.gif" alt="Telegram" className="tgh-gif" />
          </button>
          
          <div className="header-balance">
            <span className="balance-amount">${formatNumber(usdtBalance, 0)}</span>
          </div>

          <button className="header-btn wallet-btn" onClick={onDisconnect}>
            {formatAddress(account)}
          </button>
        </div>
      </div>
    </header>
  );
};

export default Header;
